import {doc, getDoc, setDoc} from 'firebase/firestore';
import {db} from '../../../shared/services/firebase';
import {fail, logError, ok, toConfigError} from './apiHelpers';

/**
 * Fetch markdown documentation text for an edge.
 */
export const getConfigText = async (edgeId) => {
  try {
    const snap = await getDoc(doc(db, 'edges', edgeId, 'configurations', 'configText'));
    if (!snap.exists()) return ok({value: '', updatedAt: null});
    const data = snap.data();
    return ok({
      value: data.value || '',
      updatedAt: data.updatedAt ? data.updatedAt.toDate() : null,
    });
  } catch (error) {
    const errorInfo = toConfigError(error, 'CONFIG_LOAD_FAILED');
    logError('getConfigText', errorInfo);
    return fail(errorInfo);
  }
};

/**
 * Save markdown documentation text for an edge.
 */
export const saveConfigText = async (edgeId, content) => {
  try {
    await setDoc(
      doc(db, 'edges', edgeId, 'configurations', 'configText'),
      {value: content, updatedAt: new Date()},
      {merge: true}
    );
    return ok();
  } catch (error) {
    const errorInfo = toConfigError(error, 'CONFIG_SAVE_FAILED');
    logError('saveConfigText', errorInfo);
    return fail(errorInfo);
  }
};

